module.exports = __webpack_public_path__ + "static/media/icnScrollDownAceptar.39fb9ba3.svg";